export default __webpack_public_path__ + "static/media/cp_geo_sv.c5b7a88d.svg";